exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".leave-comment-part textarea[data-v-979bf8b6]{min-height:120px}.leave-comment-part button[data-v-979bf8b6]{margin-right:5px}", ""]);

// exports
